/* eslint-disable */ // TODO: FIX ALL ESLINT ERRORS HERE!!!!
import { memo, useCallback, useEffect, useRef, useState } from 'react';

import {
  ConditionType,
  ContentType,
  EntityType,
  GameCondition,
  GameLock,
  GameLockPathTransitionType,
  LockLocationType,
  LockType,
} from '@/_models/Game';
import { TourType } from '@/_models/Tour';
import { ConditionLocationType, GameStatus, vsTriggerType } from '../../../types';

import { Polygon } from '@/_models/virtualStaging/Polygon';
import { TourImage, TourObject, TourVideo, VSTourAsset } from '@/_models/virtualStaging/VSObject';
import { color } from '@/utils/index';
import styled, { useTheme } from 'styled-components';
import { useGlobalDOMEvents } from '../../../../hooks';
import ConditionModal from '../ConditionModal';

import {
  asyncStore,
  handlePathDelay,
  parsePathDestinationSweepData,
  parseTourLink,
} from '@/_helpers/base';
import { TTheme } from '@/_models/Common';
import { ChapterType } from '@/_models/game/GameBook';
import { videoRendererType } from '@/_models/virtualStaging/VideoRenderer.component';
import { gameLockData } from '@/components/GameTour';
import { GameLockPathModal, iTHREE } from '@treedis/tour-loader';
import Sidebar from 'components-new/common/sidebar/Sidebar';
import DesktopSwitchPath from 'components-new/eCommerce/DesktopSwitchPath';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Tween } from 'three/examples/jsm/libs/tween.module';
import { degToRad } from 'three/src/math/MathUtils';
import { AudioModule } from '../../../../components-new/common/AudioModule';
import {
  bottomBarOpenState,
  forceShowPathSwitchMobileModalState,
  gamePointsState,
  gameSoundOnState,
  gameSoundVolumeState,
  tourConfigsState,
  useRecoilState,
  useRecoilValue,
} from '../../../../store';
import { GameBookHandle } from '../GameBookHandle';
import GuideModal from '../GuideModal';
import { TimeIsUpModal } from '../TimeIsUpModal';
import { TimerWrap } from '../TimerWrap';
import { TGameplayScreen } from './types';
import { NYTIMES_TOUR_SLUGS } from '../../config';
import { ControllerType } from '@/_models/virtualStaging/HTMLMesh/component/Menu/types';

let tagsInitComplete = false;
let lockElementsInitComplete = false;
const pathSnapshot = asyncStore?.pathSnapshot;
let skipPathTo;

let pathGameLockDataSnapshots: Record<
  number,
  Record<number, { disable: boolean; attempts: number }>
> = {};
const audioHandler = AudioModule.getInstance();

const GamePathLockStyleFix = styled.div`
  .path-lock-title {
    display: flex;
    align-items: center;
    margin-top: 4px;
  }

  .path-lock-titleWrap {
    padding-bottom: 3px;
  }
`;

const GameplayScreen = (props: TGameplayScreen) => {
  const {
    isSubtitleVisible,
    toggleVisibleTags,
    renderer,
    camera,
    pose,
    THREE,
    changeGameCondition,
    translation,
    game,
    tour,
    tourType,
    showcase,
    showcaseLoaded,
    gameStatus,
    username,
    lockSolved,
    allTags,
    polygons,
    modelNodes,
    showHintModal,
    initialDuplicates,
    // openedLock,
    analytic,
    vsObjects,
    sweeps,
    clickedElements,
    // closedElementPopup,
    unlockedChapterIds,
    showBookBtn,
    showGuide,
    whiteLabel,
    pathfinderDataState,
    // callbacks
    setPathfinderDataState,
    initPolygon,
    setGameStatus,
    onGameEnd,
    conditionToBackpack,
    closeGameBook,
    tryButtonPlaySound,
    onToggleGameBookModal,
    toggleGuide,
    callExperiencePopup,
    moveToSweep,
    setVSVisible,
    setGameState,
    openVsIframe,
    handleCurrentCondition,
    filterVsElementsByGameCondition,
    availableSweeps = [],
    currentSweep,
    isClosedGameGenially,
    backpackNewItems,
    isShowPathLockByExperience,
    removeFromCollectItemsBackpack,
    removeFromClickedElements,
    panoIsOpen,
    clickedElement,
    // Sidebar
    showBackpack,
    showBook,
    setBaseState,
    setRotation,

    // Hub
    showParticipantsIcon,
    showParticipantsReel,
    host,
    participantId,
    // audio
    mainPlaying,
    isEnableNextStep,
    setPassedPath,
    getTagIconId,
    registerIcon,
    editIcon,
    resetIcon,
    distanceToNextPathStep,
    vrEventManager,
  } = props;

  const isTourLoad = useRef(false);
  const [isEnableNextPathLock, toggleNextPathLock] = useState(true);
  const [isMovingToPath, setIsMovingToPath] = useState(false);
  const [isEnablePrevPathLock, togglePreviosPathLock] = useState<boolean>(false);
  const [soundOn] = useRecoilState(gameSoundOnState);
  const [volume] = useRecoilState(gameSoundVolumeState);
  const [delayedDisable, setDelayedDisable] = useState(true);
  const [finishedPaths, setFinishedPaths] = useState<number[]>([]);
  const [_, setUpdateState] = useState<boolean>(false);

  // Temporary logic for two NYTimes tours
  // @ts-ignore
  const nyTimesTagsRef = useRef<Map<any, any>>(allTags);

  const baseReferenceSpace = useRef(null);
  const lockPathAudioClick = useRef<HTMLAudioElement>(null);
  const hintVideoRef = useRef<HTMLIFrameElement>(null);
  const [forceShowPathSwitchMobileModal, setForceShowPathSwitchMobileModal] = useRecoilState(
    forceShowPathSwitchMobileModalState,
  );

  const popupsToFulfill = useRef<any>();
  const theme: TTheme = useTheme();

  const [gamePoints, setGamePoints] = useRecoilState(gamePointsState);
  const [solvedLocks, setSolvedLocks] = useState<number[]>([]);
  const [conditionModalObjects, setConditionModalObjects] = useState<any[]>([]);
  const [conditionModalItem, setConditionModalItem] = useState<number>(0);
  const [currentCondition, setCurrentCondition] = useState<GameCondition>(null);
  const [revealedConditions, setRevealedConditions] = useState<number[]>([]);
  // modals
  const [showTimeIsUpModal, setShowTimeIsUpModal] = useState<boolean>(false);
  const [showConditionModal, setShowConditionModal] = useState<boolean>(false);
  //@ts-ignore
  const [isClickPrev, setIsClickPrev] = useState<boolean>(false);
  const [lockPath, setLockPath] = useState(null);
  const previousPathStep = useRef<any>({});
  const currentPathStep = useRef<any>(null);
  const paths = useRef(new Map());
  const gameTimeRef = useRef<number>(0);
  const cameraPose = useRef(null);
  const defaultLockWasSet = useRef(false); // ref to track if the effect has run
  const gltfLoader = useRef(null);
  const mixer = useRef(null);
  const clock = useRef(null);
  const pathEndMark = useRef(null);
  const lastStepRef = useRef(null);

  const timerCondition =
    tourType === TourType.Game &&
    showcaseLoaded &&
    (gameStatus === GameStatus.Started ||
      gameStatus === GameStatus.SuccessfullyEndedWithoutFinalScreen);
  const baseCondition =
    tourType === TourType.Game && showcaseLoaded && gameStatus === GameStatus.Started;

  const isRtl = tour.client?.rtl;
  const hasClientLogo = tour?.client?.logo;

  const tagRefForData = useRef<any>();
  tagRefForData.current = { lockPath, allTags, finishedPaths };
  asyncStore.currentPathStep = currentPathStep.current;

  useGlobalDOMEvents(
    {
      keyup: (ev: KeyboardEvent) => {
        if (ev.code === 'Space') {
          handleNextStep();
        }
      },
    },
    [vsObjects, allTags],
  );

  const [hidePath, setHidePath] = useState(false);

  // Specific logic for two NYTimes tours
  useEffect(() => {
    if (
      hidePath === isSubtitleVisible ||
      !NYTIMES_TOUR_SLUGS.some((slug) => window.location.pathname.includes(slug))
    )
      return;
    // Toggle Path Visibility
    setHidePath(!hidePath);
    toggleVisibleTags(nyTimesTagsRef.current, hidePath);
  }, [isSubtitleVisible, hidePath]);

  useEffect(() => {
    const audio = new Audio();
    audio.src = '/audio/lock-path-click.wav';
    audio.volume = volume;
    audio.autoplay = false;
    audio.load();
    lockPathAudioClick.current = audio;
  }, []);

  useEffect(() => {
    console.debug('-----------------experience props-----------------', props);
  }, []);

  useEffect(() => {
    const isClickedCurrentStep = clickedElements.some((item) => {
      return (
        currentPathStep?.current?.locationType === item.type &&
        (currentPathStep?.current?.locationItem === item.value ||
          currentPathStep?.current?.locationItem === item.sid ||
          currentPathStep?.current?.locationItem === item.defaultSid ||
          currentPathStep?.current?.locationItem === item.value?.toString())
      );
    });
    // if (isClickedCurrentStep && openedLock?.type !== LockType.Code && !isClickPrev && openedLock?.type !== LockType.Genially) {
    if (isClickedCurrentStep) {
      if (!isClosedGameGenially) {
        goToNextStep(true).then(() => {
          // if (game.finishScreenOn && !currentPathStep?.current) {
          //   setGameStatus(GameStatus.SuccessfullyEndedWithSimpleFinalScreen);
          // }
        });
      }
    } else if (!isClickedCurrentStep && lockPath?.allowSkipping) {
      //check if currentPathStep on it's next or next of it's next contain clickedElements id, type
      //run goToNextStep x times
      let nextStepTimes = 0;
      let elementFound = false;
      let currentStep = currentPathStep?.current;
      while (currentStep && nextStepTimes < 10) {
        if (!elementFound) {
          elementFound = clickedElements.some((item) => {
            return (
              currentStep?.locationType === item.type && currentStep?.locationItem === item.value
            );
          });
        }
        const nextStepId: any = currentStep.next?.id;
        if (nextStepId) {
          currentStep = paths.current.get(nextStepId);
        } else {
          currentStep = null;
        }
        nextStepTimes++;
      }

      if (elementFound) {
        for (let i = 0; i < nextStepTimes - 1; i++) {
          goToNextStep();
        }
      }
    }
    // don`t put openedLock
  }, [clickedElements, isClosedGameGenially]);

  const handleTagClick = (tagId: string) => {
    if (
      !tagRefForData.current ||
      !tagRefForData.current.allTags ||
      Array.from(tagRefForData.current.allTags).length === 0
    )
      return;
    const tag: any = tagRefForData?.current?.allTags?.get(tagId);
    const tagClone = { ...tag };
    tagClone.type = 'tag';
    belongToCurrentPath(tagClone) || belongToOtherPath(tagClone);
    const belongsToAnyPath = belongToCurrentPath(tagClone) || belongToOtherPath(tagClone);
    if (!belongsToAnyPath) {
      const pathSwitchers = game?.paths?.map((lock) => lock.pathSwitcher).filter((value) => value);
      const foundTagSwitch = pathSwitchers?.find(
        (ps) => ps.tagSid === tagClone.sid || ps.tagSid === tagClone.defaultSid,
      );
      if (foundTagSwitch) {
        handleChangePath({ target: { value: foundTagSwitch.gameLockId, fromTag: true } });
      }
    }
  };

  useEffect(() => {
    if (showcase) {
      showcase.App.state.subscribe((appState) => {
        if (appState.phase === showcase.App.Phase.PLAYING) {
          isTourLoad.current = true;
        }
      });
      //be careful we're loosing context on tag click handler, if you need up to date data use ref or render gameplay screen later
      showcase.on(showcase.Mattertag.Event.CLICK, handleTagClick);

      showcase.on(showcase.Camera.Event.MOVE, async (p: any) => {
        cameraPose.current = p;
      });
    }
  }, [showcase]);

  const getLockPoint = (lockId) => {
    const lock = (game?.locks || []).find((lock) => lock.id === lockId);
    return lock?.point || 0;
  };

  const createPath = (items: Map<any, any>, triggerType: LockLocationType, triggerItem: number) => {
    const step = lockPath?.paths?.find(
      (path) =>
        path.triggerType === triggerType &&
        (path.triggerItem === triggerItem || (path.triggerItem === null && triggerItem === -1)),
    );
    if (!step) return items;
    if (step.locationType === EntityType.Tag) {
      const allTagsArray = Array.from(allTags, ([, value]: any) => value);
      step.element = allTagsArray.find(
        (tag) =>
          tag?.id === step.locationItem ||
          tag?.sid === step.locationItem ||
          tag?.defaultSid === step.locationItem,
      );
    } else if (step.locationType === EntityType.Polygon) {
      step.element = polygons.find(
        (polygon) =>
          polygon.id === step.locationItem || polygon.id?.toString() === step.locationItem,
      );
    } else if (step.locationType === EntityType.VSImage) {
      step.element = vsObjects.find(
        (object) =>
          object instanceof TourImage &&
          (object.id === step.locationItem || object.id?.toString() === step.locationItem),
      );
    } else if (step.locationType === EntityType.VSVideo) {
      step.element = vsObjects.find(
        (object) =>
          object instanceof TourVideo &&
          (object.id === step.locationItem || object.id?.toString() === step.locationItem),
      );
    } else if (step.locationType === EntityType.VSItem) {
      step.element = vsObjects.find(
        (object) =>
          object instanceof TourObject &&
          (object.id === step.locationItem || object.id?.toString() === step.locationItem),
      );
    }

    const next = lockPath?.paths.find(
      (path) => path.triggerType === step.locationType && path.triggerItem === step.locationItem,
    );
    const prev = lockPath?.paths.find(
      (path) => path.locationType === step.triggerType && path.locationItem === step.triggerItem,
    );

    if (!triggerType) {
      previousPathStep.current = currentPathStep.current;
      currentPathStep.current = {
        ...step,
        prev: prev || null,
        next: next && next.id !== step.id ? next : null,
      };

      const delay = parseInt(step?.appearanceDelay);
      //if delay then path will appear with timeout / reset previous timeout
      handlePathDelay(delay, setDelayedDisable);
    }
    items.set(step.id, {
      ...step,
      prev: prev || null,
      next: next && next.id !== step.id ? next : null,
    });
    asyncStore.pathIds.push(step.id);
    return next && !items.get(next.id)
      ? createPath(items, next.triggerType, next.triggerItem)
      : items;
  };

  const initLockElements = async () => {
    if (gameStatus === GameStatus.Started && !paths.current?.size && !lockElementsInitComplete) {
      lockElementsInitComplete = true;
      console.debug('----- init lock elements -----');
      await hideItemsFromConditions();
    }
  };

  const initLockPath = async () => {
    if (lockPath && !paths.current?.size) {
      asyncStore.pathIds = [];
      paths.current = createPath(new Map(), null, -1);
      let pathArray = Array.from(paths.current, ([, value]: any) => value);

      if (pathArray.length && lockPath.endPathIcon && sweeps?.length) {
        createPathEndMark(pathArray);
      }

      pathArray = pathArray.filter((e) => e.id !== currentPathStep?.current?.id);
      if (lockPath?.hideItems) {
        await hideElements({
          hideTags: pathArray
            .filter((v) => v.locationType === EntityType.Tag)
            .map((e) => e.element?.sid),
          polygonsToHide: pathArray
            .filter((v) => v.locationType === EntityType.Polygon)
            .map((e) => e.element?.id?.toString()),
          vsImagesToHide: pathArray
            .filter((v) => v.locationType === EntityType.VSImage)
            .map((e) => e.element?.id?.toString()),
          vsVideosToHide: pathArray
            .filter((v) => v.locationType === EntityType.VSVideo)
            .map((e) => e.element?.id?.toString()),
          vsItemsToHide: pathArray
            .filter((v) => v.locationType === EntityType.VSItem)
            .map((e) => e.element?.id?.toString()),
        });
      }
      if (skipPathTo) {
        goToNextStep();
      } else {
        //screen render update, because changing ref not trigger rerender
        setUpdateState((updateState) => !updateState);
      }
    }
  };

  //<editor-fold desc="Logic for 3d Mark model on Sweep at the current path end>
  const createPathEndMark = (pathArray) => {
    if (pathEndMark.current) {
      removePathEndMark();
    }

    const lastStep = pathArray.at(-1);
    const targetSweep = sweeps.find((sweep) => sweep.uuid === lastStep.sweepUuid);
    const { x, y, z } = targetSweep.position;

    gltfLoader.current.load('/models/pathEndMark.glb', function (gltf) {
      camera.parent.parent.add(gltf.scene);
      gltf.scene.scale.setScalar(0.1);
      gltf.scene.position.set(x, y - 0.3, z);

      mixer.current = new THREE.AnimationMixer(gltf.scene);
      const clips = gltf.animations;
      clips.forEach((clip) => {
        mixer.current.clipAction(clip).play();
      });
      pathEndMark.current = gltf.scene;
      lastStepRef.current = lastStep;
      updatePathEndMarkVisibility();
    });

    console.log('Path array last item', lastStep.sweepUuid, sweeps, lastStep);
    console.log(
      'Path array last item sweep',
      sweeps.find((sweep) => sweep.uuid === lastStep.sweepUuid),
    );
  };

  const removePathEndMark = () => {
    camera.parent.parent.remove(pathEndMark.current);
    pathEndMark.current = null;
  };

  const updatePathEndMarkVisibility = () => {
    if (pathEndMark.current && lastStepRef.current && currentPathStep.current) {
      if (!currentPathStep.current.next && currentSweep.uuid !== lastStepRef.current.sweepUuid)
        pathEndMark.current.visible = true;
      else pathEndMark.current.visible = false;
    }
  };

  const animate = () => {
    requestAnimationFrame(animate);
    const delta = clock.current.getDelta();
    if (mixer.current) {
      mixer.current.update(delta);
    }
  };

  useEffect(() => {
    if (sweeps.length) {
      let pathArray = Array.from(paths.current, ([, value]: any) => value);
      if (pathArray.length && lockPath.endPathIcon) {
        createPathEndMark(pathArray);
      }
    }
  }, [sweeps]);

  useEffect(() => {
    updatePathEndMarkVisibility();
  }, [currentPathStep.current]);

  useEffect(() => {
    showcase.Sweep.current.subscribe(async () => {
      updatePathEndMarkVisibility();
    });

    gltfLoader.current = new THREE.GLTFLoader();
    clock.current = new THREE.Clock();
    animate();
  }, []);
  // </editor-fold>

  const belongToCurrentPath = (fclickedElement = undefined) => {
    if (!game?.paths) return false;
    const _clickedElement = fclickedElement || clickedElement;
    const _clockPath = _clickedElement?.type === 'tag' ? tagRefForData.current?.lockPath : lockPath;
    let _skipPathTo;
    console.debug('aaa belongToCurrentPath 0 ', _clockPath);
    if (_clockPath?.allowSkipping) {
      let safeCycle = 1000; //prevent infinite loop if linked to itself or recursive
      let currentStep = currentPathStep?.current;
      console.debug('aaa belongToCurrentPath 1 allowSkipping ', currentStep, _clickedElement);

      while (safeCycle > 0 && currentStep && !_skipPathTo) {
        if (
          (currentStep?.locationItem?.toString() === _clickedElement?.id?.toString() ||
            currentStep?.locationItem?.toString() === _clickedElement?.sid ||
            currentStep?.locationItem?.toString() === _clickedElement?.defaultSid) &&
          currentStep?.locationType === _clickedElement.type
        ) {
          _skipPathTo = currentStep.id;
        }
        currentStep = paths.current?.get(currentStep?.next?.id);
        safeCycle--;
      }
      if (_skipPathTo) {
        skipPathTo = _skipPathTo;
        goToNextStep();
        return true;
      }
    } else {
      console.debug('aaa belongToCurrentPath 2', currentPathStep, _clickedElement);
      //also check if it's belong to future steps & allowSkipping enabled
      if (
        (currentPathStep?.current?.locationItem?.toString() === _clickedElement.id?.toString() ||
          currentPathStep?.current?.locationItem?.toString() === _clickedElement?.sid ||
          currentPathStep?.current?.locationItem?.toString() === _clickedElement?.defaultSid) &&
        currentPathStep?.current?.locationType === _clickedElement.type
      ) {
        goToNextStep();
        return true;
      }
      return false;
    }
  };

  const belongToOtherPath = (fclickedElement = undefined) => {
    if (!game?.paths) return false;
    const _clickedElement = fclickedElement || clickedElement;
    const _clockPath = _clickedElement?.type === 'tag' ? tagRefForData.current?.lockPath : lockPath;
    //get all paths, then check for current of future steps on pathSnapshot
    //same for paths exclude those from pathSnapshot
    //switching to first found path (in progress paths are prioritized)

    //in progress not current paths
    //OVERWRITE of finishedPaths
    const finishedPathsRef = tagRefForData.current?.finishedPaths;
    //@ts-ignore
    const filteredInProgressPathIds = Object.keys(pathSnapshot).filter(
      //@ts-ignore
      (snapshot, key) =>
        !finishedPathsRef.includes(key) &&
        !finishedPathsRef.includes(parseInt(key)) &&
        _clockPath?.id !== key,
    );
    //not in progress not current paths
    //@ts-ignore
    const filteredPaths =
      game?.paths?.filter(
        (path) =>
          !finishedPathsRef.includes(path.id) &&
          !filteredInProgressPathIds.includes(path.id) &&
          _clockPath?.id !== path.id,
      ) || [];
    //in progress path check
    for (let i = 0; i < filteredInProgressPathIds.length; i++) {
      const filteredInProgressPathId = filteredInProgressPathIds[i];
      const pathSnapshotItem = pathSnapshot[filteredInProgressPathId];
      const currentLockPath = game?.paths.find(
        (g) => g.id === pathSnapshotItem.currentPathStep?.gameLockId,
      );
      if (currentLockPath?.allowSkipping) {
        let safeCycle = 1000;
        let _skipPathTo;
        let currentStep = pathSnapshotItem.currentPathStep;
        while (safeCycle > 0 && currentStep && !_skipPathTo) {
          if (
            (currentStep?.locationItem?.toString() === _clickedElement.id?.toString() ||
              currentStep?.locationItem?.toString() === _clickedElement?.sid ||
              currentStep?.locationItem?.toString() === _clickedElement?.defaultSid) &&
            currentStep?.locationType === _clickedElement.type
          ) {
            _skipPathTo = currentStep.id;
          }
          currentStep = currentStep.next;
          safeCycle--;
        }
        if (_skipPathTo) {
          skipPathTo = _skipPathTo;
          handleChangePath({ target: { value: filteredInProgressPathId } });
          break;
        }
      } else {
        if (
          (pathSnapshotItem.currentPathStep?.locationItem?.toString() ===
            _clickedElement.id?.toString() ||
            pathSnapshotItem.currentPathStep?.locationItem?.toString() === _clickedElement?.sid ||
            pathSnapshotItem.currentPathStep?.locationItem?.toString() ===
              _clickedElement?.defaultSid) &&
          pathSnapshotItem.currentPathStep?.locationType === _clickedElement.type
        ) {
          handleChangePath({ target: { value: filteredInProgressPathId } });
          break;
        }
      }
    }
    //not in progress path check
    for (let i = 0; i < filteredPaths.length; i++) {
      const filteredPath = filteredPaths[i];
      if (filteredPath.allowSkipping) {
        //go through steps of path and check if it's linked to clicked element
        let _skipPathTo;
        for (let i = 0; i < filteredPath.paths.length; i++) {
          let currentStep = filteredPath.paths[i];
          if (
            (currentStep?.locationItem?.toString() === _clickedElement.id?.toString() ||
              currentStep?.locationItem?.toString() === _clickedElement?.sid ||
              currentStep?.locationItem?.toString() === _clickedElement?.defaultSid) &&
            //@ts-ignore
            currentStep?.locationType === _clickedElement.type
          ) {
            _skipPathTo = currentStep.id;
          }
        }
        if (_skipPathTo) {
          skipPathTo = _skipPathTo;
          handleChangePath({ target: { value: filteredPath.id } });
          break;
        }
      } else {
        //take first step of path and check if it's linked to clicked element
        const firstStep = filteredPath.paths.find((p) => p.triggerType === null);

        if (
          (firstStep?.locationItem?.toString() === _clickedElement.id?.toString() ||
            firstStep?.locationItem?.toString() === _clickedElement?.sid ||
            firstStep?.locationItem?.toString() === _clickedElement?.defaultSid) &&
          //@ts-ignore
          firstStep?.locationType === _clickedElement.type
        ) {
          handleChangePath({ target: { value: filteredPath.id } });
        }
      }
    }
  };

  const askForReset = (pathId) => {
    confirmAlert({
      title: '',
      message:
        translation.restartPath || 'Do you wish to restart this path or continue where you left?',
      buttons: [
        {
          label: translation.restart || 'Restart',
          onClick: () => {
            skipPathTo = null;
            _changePath(pathId, true);
          },
        },
        {
          label: translation.continue || 'Continue',
          onClick: () => {
            _changePath(pathId);
          },
        },
      ],
    });
  };

  const handleChangePath = (ev: any) => {
    const { value, fromTag } = ev.target;
    if (fromTag ? tagRefForData.current?.lockPath?.id === value : lockPath?.id === value) return;
    const targetPath = game?.paths?.find((p) => p.id === value || p.id?.toString() === value);
    const pathId = value;
    if (fromTag ? tagRefForData.current?.lockPath !== null : lockPath !== null) {
      confirmAlert({
        title: '',
        message:
          translation.switchPath ||
          'Are you sure you wish to begin a new path? The current path will be turned off',
        buttons: [
          {
            label: translation.yes || 'Yes',
            onClick: () => {
              if (targetPath?.pathSetting?.resetPathOnSwitch) {
                setTimeout(() => {
                  askForReset(pathId);
                }, 1000);
              } else {
                _changePath(pathId);
              }
            },
          },
          {
            label: translation.no || 'No',
            onClick: () => {
              skipPathTo = null;
            },
          },
        ],
      });
    } else {
      _changePath(pathId);
    }
  };

  useEffect(() => {
    if (clickedElement) {
      console.debug('aaa ~~~~~ clickedElement', clickedElement);
      const isBelongToCurrentPath = belongToCurrentPath();
      const isBelongToOtherPath = !isBelongToCurrentPath && belongToOtherPath();

      if (!isBelongToCurrentPath && !isBelongToOtherPath) {
        let pathSwitchers = [];
        const extractPathSwitchers = (items) =>
          items.map((item) => item.pathSwitcher).filter((value) => value);
        if (game.locks && !game.paths) {
          pathSwitchers = extractPathSwitchers(game.locks);
        } else if (game.paths) {
          pathSwitchers = extractPathSwitchers(game.paths);
        }

        if (clickedElement.type === 'polygon') {
          const foundPolygonSwitch = pathSwitchers.find((ps) => ps.polygonId === clickedElement.id);
          if (foundPolygonSwitch) {
            handleChangePath({ target: { value: foundPolygonSwitch.gameLockId } });
          }
        } else if (clickedElement.type === 'vsImage') {
          const foundVSImageSwith = pathSwitchers.find(
            (ps) => ps.tourVSImageId === clickedElement.id,
          );
          if (foundVSImageSwith) {
            handleChangePath({ target: { value: foundVSImageSwith.gameLockId } });
          }
        } else if (clickedElement.type === 'vsVideo') {
          const foundVSVideoSwitch = pathSwitchers.find(
            (ps) => ps.tourVSVideoId === clickedElement.id,
          );
          if (foundVSVideoSwitch) {
            handleChangePath({ target: { value: foundVSVideoSwitch.gameLockId } });
          }
        } else if (clickedElement.type === 'vsItem') {
          const foundVSItem = pathSwitchers.find((ps) => ps.tourVSObjectId === clickedElement.id);
          if (foundVSItem) {
            handleChangePath({ target: { value: foundVSItem.gameLockId } });
          }
        }
      }
      console.debug(
        'aaa isBelongToCurrentPath isBelongToOtherPath',
        isBelongToCurrentPath,
        isBelongToOtherPath,
      );
    }
  }, [clickedElement]);

  useEffect(() => {
    initLockElements();
  }, [polygons, vsObjects, gameStatus]);

  useEffect(() => {
    initLockPath();
  }, [lockPath]);

  useEffect(() => {
    console.debug('--hook experience 0');
    if (game && !defaultLockWasSet.current) {
      console.debug('--hook experience 1');
      console.debug('-------------experience -----------------', game);
      console.debug('-------------experience locks-----------------', game.locks);
      console.debug('-------------experience conditions-------------', game.conditions);

      const paths = game.paths;
      if (Array.isArray(paths) && paths.length) {
        const defaultLock = paths.find((path) => path?.pathSetting?.defaultPath);
        if (paths.length > 1 && defaultLock) {
          asyncStore.regularActivePath = paths.map((path) => path.id).indexOf(defaultLock.id);
          setLockPath(defaultLock);
        } else if (paths.length === 1) {
          asyncStore.regularActivePath = 0;
          setLockPath(paths[0]);
        }
      }
      defaultLockWasSet.current = true;
    }
  }, [game]);

  useEffect(() => {
    handleCurrentCondition(showConditionModal);
  }, [showConditionModal]);

  useEffect(() => {
    console.debug(lockSolved, 'lockSolved');

    const handleGameCompletion = (lockPoint) => {
      const nextGameStatus: any = game.outroClip
        ? GameStatus.OutroClip
        : game.finishScreenOn
        ? GameStatus.SuccessfullyEnded
        : GameStatus.SuccessfullyEndedWithoutFinalScreen;

      const point = gamePoints + (lockPoint || game?.lock_points);
      setGamePoints(point);
      analytic.setPoint(point);

      analytic
        .update({
          point: point,
          completed:
            nextGameStatus === GameStatus.SuccessfullyEnded ||
            nextGameStatus === GameStatus.SuccessfullyEndedWithSimpleFinalScreen ||
            nextGameStatus === GameStatus.SuccessfullyEndedWithoutFinalScreen,
        })
        .finally(() => {
          onGameEnd();
          setGameStatus(nextGameStatus);
        });
    };

    const handleNextLock = (lockId, lockPoint) => {
      const newSolvedLocks = [...solvedLocks, lockId];
      _checkConditionsAndRevealItems(newSolvedLocks);
      setSolvedLocks(newSolvedLocks);
      asyncStore.pushLockPathTimeline(currentPathStep.current?.id, {
        ...(lockSolved?.lock || {}),
        lockId,
        lockPoint,
      });
      const point = gamePoints + lockPoint;
      setGamePoints(point);
      //would trigger more that once for game which gave steps back
      analytic.update({ point });
    };

    const handleLockSolved = () => {
      if (!lockSolved || solvedLocks.includes(lockSolved?.lock?.id)) {
        return;
      }
      const {
        lock: { id: lockId, last: lastLock, type, allowWrongAnswer },
        result,
      } = lockSolved;
      const allowNextLock = type === LockType.PopUpTrivia && allowWrongAnswer;
      if (!result && !allowNextLock) {
        return;
      }
      const lockPoint = allowNextLock && !result ? 0 : getLockPoint(lockId);
      if (lastLock || solvedLocks.length + 1 >= game.locks.length) {
        handleGameCompletion(lockPoint);
      } else {
        handleNextLock(lockId, lockPoint);
      }
    };

    handleLockSolved();
  }, [lockSolved]);

  const muteAllVsVideos = () => {
    const vsVideos = vsObjects?.filter((obj) => obj.node?.componentType === videoRendererType);

    vsVideos?.forEach((obj) => {
      const { video, muteBtn } = obj.node;
      if (video && muteBtn) {
        video.muted = true;
        muteBtn.active = true;
        muteBtn.makeBtn(muteBtn.inputs.src);
      }
    });
  };

  useEffect(() => {
    if (!currentCondition) return;
    if (currentCondition.content_type === ContentType.Video) {
      audioHandler.stopTourMusic();
    }

    const isExperiencePopupContentType =
      currentCondition.content_type === ContentType.ExperiencePopupVideo ||
      currentCondition.content_type === ContentType.ExperiencePopupImage;

    if (isExperiencePopupContentType) {
      muteAllVsVideos();
      callExperiencePopup({
        experiencePopUpData: {
          title: currentCondition.experienceTitle,
          description: currentCondition.experienceDescription,
          url: currentCondition.content_value,
          prefixImageUrl: `/games/${game.id}/conditions/${currentCondition.id}/`,
          autoClose: currentCondition.autoClose,
        },
        experiencePopUpIsOpen: true,
        onExperienceCloseCallback: closeConditionPopup,
      });
    } else {
      setShowConditionModal(true);
      setTimeout(async () => {
        await audioHandler.stopTourMusic();
      }, 1000);
    }
  }, [currentCondition]);

  const closeConditionPopup = async () => {
    handleExpPopClose();
    if (conditionModalItem < conditionModalObjects.length - 1) {
      setConditionModalItem(conditionModalItem + 1);
      setCurrentCondition(conditionModalObjects[conditionModalItem + 1]);
    } else {
      setShowConditionModal(false);
      setCurrentCondition(null);
      setConditionModalItem(0);
      setConditionModalObjects([]);
      await audioHandler.resumeMusic();
    }
    if (currentCondition.gameBackpack) {
      conditionToBackpack(currentCondition);
    }
  };

  useEffect(() => {
    if (showHintModal === false) {
      if (hintVideoRef.current) {
        hintVideoRef.current.src = hintVideoRef.current.src;
      }
    }
  }, [showHintModal]);

  const getCurrentLanguage = useCallback(() => {
    const pathnameSplitted = window.location.pathname.split('/');
    const currentSlug = pathnameSplitted[pathnameSplitted.length - 1];
    return initialDuplicates.find((duplicate: any) => duplicate.slug === currentSlug);
  }, [initialDuplicates]);

  const _checkConditionsAndRevealItems = (solvedLocks: number[]) => {
    const { conditions } = game;
    const conditionsToReveal = conditions
      .reduce((accum: any, condition: GameCondition) => {
        // solvedLocks = current solvedLock + solvedLocks
        // reveal all fulfilled except conditions already revealed (hided ∈ revealed)
        const conditionIsFulfilled = condition.lock_ids.reduce((acc: boolean, id: number) => {
          if (solvedLocks.includes(id)) return acc && true;
          return false;
        }, true);
        if (conditionIsFulfilled && !revealedConditions.includes(condition.id))
          accum.push(condition);
        return accum;
      }, [])
      .filter((item) => item.lock_ids?.length > 0); // remove conditions after first lockSolved;
    __revealConditions(
      conditionsToReveal.filter((condition) => condition.conditionType === ConditionType.REVEAL),
    );
    __hideConditions(
      conditionsToReveal.filter((condition) => condition.conditionType === ConditionType.HIDE),
    );
  };
  const hideItemsFromConditions = async () => {
    if (!tagsInitComplete) {
      // VSItems.indexOf(item?.id?.toString()) !== -1
      const { startGameHideConditions } = filterVsElementsByGameCondition();
      // conditions with empty lockId (experience start)
      await __hideConditions(startGameHideConditions);
      tagsInitComplete = true;
    }
  };

  const handleMoveToSweep = (condition: GameCondition) => {
    try {
      if (
        condition.teleportLocationType === ConditionLocationType.sweep &&
        condition.teleportToSweep
      ) {
        moveToSweep(String(condition.teleportToSweep));
      } else if (
        condition.teleportLocationType === ConditionLocationType.tourLink &&
        condition.teleportLocationTourLink
      ) {
        const parsedLink = parseTourLink(condition.teleportLocationTourLink);
        if (parsedLink) {
          moveToSweep(String(parsedLink.s), { x: parsedLink.x, y: parsedLink.y });
        } else {
          console.error('experience handleMoveToSweep link parse err');
        }
      } else {
        console.error('experience handleMoveToSweep no locationType');
      }
    } catch (err) {
      console.error("experience handleMoveToSweep can't move to sweep");
    }
  };

  const __revealConditions = async (
    conditions: any[],
    options?: { skipAddToRevealed: boolean },
  ) => {
    // this.showcase.Sweep.disable(sweep.uuid, sweep2.uuid,...)
    // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
    const hasGamePath = game?.paths?.length > 0 && paths?.current?.size > 0;
    if (hasGamePath) {
      if (currentPathStep?.current === null && previousPathStep?.current) return;
    }
    if (!conditions.length) return;
    let _tags = [];
    let polygonsToReveal = [];
    let vsItemsToReveal = [];
    let vsVideosToReveal = [];
    let vsImagesToReveal = [];
    let sweeps = [];
    let popups = [];
    const currentRevealedConditions = [];

    conditions.forEach((condition: GameCondition) => {
      if (!condition.entity_ids) return;
      if (condition.entity_type === EntityType.Tag) {
        _tags = [..._tags, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Polygon) {
        polygonsToReveal = [...polygonsToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSItem) {
        vsItemsToReveal = [...vsItemsToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSVideo) {
        vsVideosToReveal = [...vsVideosToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSImage) {
        vsImagesToReveal = [...vsImagesToReveal, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Sweep) {
        sweeps = [...sweeps, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Popup) {
        popups = [...popups, condition];
      }
      changeGameCondition(condition.id, 'isRevealed', true);
      currentRevealedConditions.push(condition.id);
      // teleport to sweep
      if (condition.teleportToSweep && condition.teleportToSweep !== 'false') {
        //teleport after all popups will be closed
        if (popups.length > 0) {
          popupsToFulfill.current = {
            length: popups.length,
            cb: () => handleMoveToSweep(condition),
          };
        } else {
          popupsToFulfill.current = null;
          setTimeout(() => {
            handleMoveToSweep(condition);
          }, 200);
        }
      }
    });
    if (!options?.skipAddToRevealed) {
      asyncStore.pushRevealPathTimeline(currentPathStep.current?.id, conditions);
      setRevealedConditions((revealedConditions) => [
        ...revealedConditions,
        ...currentRevealedConditions,
      ]);
    }

    console.debug('-----------enabling sweeps-----------', sweeps);
    //filter first of all (using map for example)
    //then filter for existing
    const uniqueCondSweeps = new Set(sweeps);
    const availableCondSweeps = Array.from(uniqueCondSweeps).filter((s: string) =>
      availableSweeps.includes(s),
    );
    showcase.Sweep.enable(...availableCondSweeps).catch((err) => console.error(err));

    const allTagsArray = Array.from(allTags, ([, value]: any) => value);

    const tagsToShow = _tags.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );

    tagsToShow?.forEach((tag: any) => {
      if (!tag) return;
      // Add tag to the nyTimesTagsRef map
      nyTimesTagsRef.current.set(tag.sid, tag);

      _changeTagPos(tag, true);
    });

    if (popups.length) {
      console.debug('-----------revealing popups ----------', popups);
      await audioHandler.stopTourMusic();
      setConditionModalObjects(popups);
      setCurrentCondition(popups[conditionModalItem]);
    }
    if (polygons && polygons.map) {
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (
            polygonsToReveal.indexOf(item?.id?.toString()) !== -1 ||
            polygonsToReveal.indexOf(item?.id) !== -1
          ) {
            if (!item.active) {
              console.debug('-----------not revealing polygons (inactive)----------', item);
            }
            console.debug('-----------revealing polygons ----------', item);
            if (!item.uuid) {
              const node = await initPolygon(item);
              modelNodes.push(node);
              item.uuid = node[0].obj3D.uuid;
            }
          }
        }),
      );
    }

    await Promise.all(
      (vsObjects || []).map(async (item: VSTourAsset) => {
        let targetObjToReveal;

        if (item instanceof TourImage) {
          targetObjToReveal = vsImagesToReveal;
        } else if (item instanceof TourVideo) {
          targetObjToReveal = vsVideosToReveal;
        } else {
          targetObjToReveal = vsItemsToReveal;
        }

        if (
          targetObjToReveal &&
          (targetObjToReveal.indexOf(item?.id?.toString()) !== -1 ||
            targetObjToReveal.indexOf(item?.id) !== -1)
        ) {
          if (item && !item.active) return item;
          console.debug('-----------revealing vsItem ----------', item);
          const poseT = new THREE.Vector3(pose?.position?.x, pose?.position?.y, pose?.position?.z);
          const assetPose = new THREE.Vector3(item.positionX, item.positionY, item.positionZ);
          // Multiply by 0.2 because 1 three.js unit is approximately 20cm
          const distance = poseT.distanceTo(assetPose) * 0.2;
          const inRange = distance <= (item?.renderRange || tour?.vsRenderRange || 25);
          if (inRange) {
            await setVSVisible(item, true, vsTriggerType.revealCondition);
          } else {
            await setVSVisible(item, false, vsTriggerType.revealCondition);
          }

          return {
            ...item,
          };
        }
      }),
    );
  };
  const __hideConditions = async (conditions: any[], options?: { skipAddToRevealed: boolean }) => {
    // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
    //@ts-ignore
    if (!conditions?.length) return;
    let _tags = [];
    let polygonsToHide = [];
    let vsItemsToHide = [];
    let vsVideosToHide = [];
    let vsImagesToHide = [];
    let sweeps = [];
    const currentRevealedConditions = [];

    conditions.forEach((condition: GameCondition) => {
      if (!condition.entity_ids) return;
      if (condition.entity_type === EntityType.Tag) {
        _tags = [..._tags, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Polygon) {
        polygonsToHide = [...polygonsToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSItem) {
        vsItemsToHide = [...vsItemsToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSVideo) {
        vsVideosToHide = [...vsVideosToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.VSImage) {
        vsImagesToHide = [...vsImagesToHide, ...condition.entity_ids];
      } else if (condition.entity_type === EntityType.Sweep) {
        sweeps = [...sweeps, ...condition.entity_ids];
      }
      changeGameCondition(condition.id, 'isHidden', true);
      currentRevealedConditions.push(condition.id);
    });
    if (!options?.skipAddToRevealed) {
      asyncStore.pushHidePathTimeline(currentPathStep?.current?.id, conditions);
      setRevealedConditions((revealedConditions) => [
        ...revealedConditions,
        ...currentRevealedConditions,
      ]);
    }

    console.debug('-----------disabling sweeps-----------', sweeps);
    //filter first of all (using map for example)
    //then filter for existing
    const uniqueCondSweeps = new Set(sweeps);
    const availableCondSweeps = Array.from(uniqueCondSweeps).filter((s: string) =>
      availableSweeps.includes(s),
    );
    showcase.Sweep.disable(...availableCondSweeps).catch((err) => console.error(err));

    const allTagsArray = Array.from(allTags, ([, value]: any) => value);

    const tagsToHide = _tags.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );
    console.debug('-----------disabling tags-----------', tagsToHide);
    tagsToHide.forEach((_tag: any) => _tag && _changeTagPos(_tag, false));

    // Removing hidden tags from nyTimesTagsRef
    const tempMap = new Map();
    nyTimesTagsRef.current.forEach((value, key) => {
      if (!tagsToHide.some((t) => t?.id === value?.id)) {
        tempMap.set(key, value);
      }
    });
    nyTimesTagsRef.current = tempMap;

    if (polygons && polygons.map) {
      console.debug('Polygons to hide', polygonsToHide, polygons);
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (
            polygonsToHide.indexOf(item?.id?.toString()) !== -1 ||
            polygonsToHide.indexOf(item?.id) !== -1
          ) {
            if (!item?.active) {
              console.debug('-----------not hiding polygon (inactive) ----------', item);
            }
            const nodeIndex = modelNodes.findIndex(
              (node: any) => node?.[0]?.obj3D?.uuid === item.uuid,
            );
            if (nodeIndex >= 0 && item.uuid) {
              console.debug('-----------hiding polygon ----------', item);
              modelNodes[nodeIndex][0].stop();
              item.uuid = null;
              modelNodes.splice(nodeIndex, 1);
            }
          }
        }),
      );
    }

    await Promise.all(
      (vsObjects || []).map(async (item: VSTourAsset) => {
        let targetObjToHide;

        if (item instanceof TourImage) {
          targetObjToHide = vsImagesToHide;
        } else if (item instanceof TourVideo) {
          targetObjToHide = vsVideosToHide;
        } else {
          targetObjToHide = vsItemsToHide;
        }

        if (
          targetObjToHide &&
          (targetObjToHide.indexOf(item?.id?.toString()) !== -1 ||
            targetObjToHide.indexOf(item?.id) !== -1)
        ) {
          if (item && !item.active) return item;
          console.debug('-----------hiding vs ----------', item);
          await setVSVisible(item, false);
          return {
            ...item,
          };
        }
      }),
    );
  };

  const showElements = async ({
    tagsToReveal,
    polygonsToReveal,
    vsImagesToReveal,
    vsVideosToReveal,
    vsItemsToReveal,
  }) => {
    const allTagsArray = Array.from(allTags, ([, value]: any) => value);
    const tagsToShow = tagsToReveal.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );
    tagsToShow.forEach((_tag: any) => _tag && _changeTagPos(_tag, true));

    let currentObjUuid: any = null;

    if (polygons && polygons.map) {
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (polygonsToReveal.indexOf(item?.id?.toString()) !== -1) {
            if (item.active && !item.uuid) {
              const node = await initPolygon(item);
              modelNodes.push(node);
              item.uuid = node[0].obj3D.uuid;
              currentObjUuid = item.uuid;
            }
          }
        }),
      );
    }

    await Promise.all(
      (vsObjects || []).map(async (item: VSTourAsset) => {
        //TODO: Change this to this.vsObjects

        let targetObjToReveal;

        if (item instanceof TourImage) {
          targetObjToReveal = vsImagesToReveal;
        } else if (item instanceof TourVideo) {
          targetObjToReveal = vsVideosToReveal;
        } else {
          targetObjToReveal = vsItemsToReveal;
        }

        if (targetObjToReveal && targetObjToReveal.indexOf(item?.id?.toString()) !== -1) {
          if (item && !item.active) return item;
          await setVSVisible(item, true);
        }
      }),
    );

    return currentObjUuid;
  };

  const hideElements = async (
    { hideTags, polygonsToHide, vsImagesToHide, vsVideosToHide, vsItemsToHide },
    initial = false,
  ) => {
    const allTagsArray = Array.from(allTags, ([, value]: any) => value);

    const tagsToHide = hideTags.map((tag: string) =>
      allTagsArray.find(
        (allTagItem: any) =>
          allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag,
      ),
    );
    console.debug('-----------disabling tags-----------', tagsToHide);
    tagsToHide.forEach((_tag: any) => _tag && _changeTagPos(_tag, false));

    if (polygons && polygons.map) {
      console.debug('(hideElements) Polygons to hide', polygonsToHide, polygons);
      await Promise.all(
        polygons.map(async (item: Polygon) => {
          if (polygonsToHide.indexOf(item?.id?.toString()) !== -1) {
            if (!item?.active) {
              console.debug('-----------not hiding polygon (inactive) ----------', item);
            }
            console.debug('-----------hiding polygon ----------', item);
            const nodeIndex = modelNodes.findIndex(
              (node: any) => node?.[0]?.obj3D?.uuid === item.uuid,
            );
            if (nodeIndex >= 0) {
              modelNodes[nodeIndex][0].stop();
              item.uuid = null;
              modelNodes.splice(nodeIndex, 1);
            }
          }
        }),
      );
    }
    await Promise.all(
      (vsObjects || []).map(async (item: VSTourAsset) => {
        let targetObjToHide;

        if (item instanceof TourImage) {
          targetObjToHide = vsImagesToHide;
        } else if (item instanceof TourVideo) {
          targetObjToHide = vsVideosToHide;
        } else {
          targetObjToHide = vsItemsToHide;
        }

        if (targetObjToHide && targetObjToHide.indexOf(item?.id?.toString()) !== -1) {
          if (item && !item.active) return item;
          console.debug('-----------hiding setVSVisible vs ----------', item);
          await setVSVisible(item, false);
          return {
            ...item,
          };
        }
      }),
    );
  };

  const _changeTagPos = (_tag, isVisible) => {
    const { sid } = _tag;
    console.debug(`-----------${isVisible ? 'revealing' : 'hiding'} tag ----------`, _tag);
    showcase.Mattertag.editOpacity(sid, isVisible ? 1 : 0).catch((e) => console.error(e));
    showcase.Mattertag.editPosition(sid, {
      anchorPosition: {
        x: isVisible ? _tag.positionX : 0,
        y: isVisible ? _tag.positionY : 0,
        z: isVisible ? _tag.positionZ : 0,
      },
      stemVector: {
        x: isVisible ? _tag.stemVectorX : 0,
        y: isVisible ? _tag.stemVectorY : 0,
        z: isVisible ? _tag.stemVectorZ : 0,
      },
      // floorIndex: isVisible ? _tag.floor : 0,
      floorIndex: _tag.floor,
    }).catch((e) => console.error(e));
  };

  const rotateCameraTo = async (t) => {
    try {
      if (asyncStore.vrIsOn) return console.error('Camera rotate is disabled for VR mode');
      const THREE = await iTHREE();

      const l = (value) => (value * Math.PI) / 180;
      const d = new THREE.Vector3(0, 0, -1);
      const a = await showcase.Camera.getPose();
      const r = new THREE.Euler(l(a.rotation.x), l(a.rotation.y), 0, 'XYZ');
      const o = d.clone().applyEuler(r);
      const s = new THREE.Vector3(a.position.x, a.position.y, a.position.z);
      const u = t.clone();
      const f = o.clone().normalize();
      const p = u.clone().sub(s).normalize();
      const m = new THREE.Vector3(f.x, 0, f.z);
      const b = new THREE.Vector3(p.x, 0, p.z);
      const h = m.angleTo(b);
      const g = f.x * p.z - f.z * p.x < 0 ? -1 : 1;
      await showcase.Camera.rotate(((180 * h) / Math.PI) * g);
    } catch (err) {
      console.error(err);
    }
  };

  const rotateVRView = (pathSweep, obj) => {
    if (!baseReferenceSpace.current) {
      baseReferenceSpace.current = renderer.xr.getReferenceSpace();
    }

    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshBasicMaterial({
      color: 0x000000,
      transparent: true,
      opacity: 0,
      depthTest: false,
      depthWrite: false,
    });
    const helperObj = new THREE.Mesh(geometry, material);
    material.side = THREE.DoubleSide;
    camera.parent.parent.add(helperObj);
    helperObj.position.set(pathSweep.position.x, pathSweep.position.y, pathSweep.position.z);

    new Tween.Tween(helperObj.material)
      .to({ opacity: 1 }, 150)
      .start()
      .onComplete(() => {
        const transform2 = new XRRigidTransform(new THREE.Vector3(), { x: 0, y: 0, z: 0, w: 1 });
        const teleportSpaceOffset2 = baseReferenceSpace.current.getOffsetReferenceSpace(transform2);
        renderer.xr.setReferenceSpace(teleportSpaceOffset2);
        setTimeout(() => {
          let posAvatar = new THREE.Vector3();
          camera.getWorldPosition(posAvatar);

          let posObj = new THREE.Vector3();
          if (obj.node) obj.node.root.getWorldPosition(posObj);
          else if (
            obj.hasOwnProperty('positionX') &&
            obj.hasOwnProperty('positionY') &&
            obj.hasOwnProperty('positionZ')
          ) {
            posObj.set(obj.positionX, obj.positionY, obj.positionZ);
          }

          const xDist = posObj.x - posAvatar.x;
          const zDist = posObj.z - posAvatar.z;
          const angle = Math.atan2(zDist, xDist);

          const quaternion = new THREE.Quaternion();
          quaternion.setFromAxisAngle(
            new THREE.Vector3(0, 1, 0),
            degToRad(cameraPose.current.rotation.y) + angle + Math.PI / 2,
          );

          const transform = new XRRigidTransform(new THREE.Vector3(), {
            x: quaternion.x,
            y: quaternion.y,
            z: quaternion.z,
            w: quaternion.w,
          });
          const teleportSpaceOffset = baseReferenceSpace.current.getOffsetReferenceSpace(transform);
          renderer.xr.setReferenceSpace(teleportSpaceOffset);

          new Tween.Tween(helperObj.material)
            .to({ opacity: 0 }, 150)
            .onComplete(() => {
              camera.parent.parent.remove(helperObj);
              geometry.dispose();
              material.dispose();
            })
            .start();
        }, 300);
      });
  };

  const moveToPathStepElement = async (
    type: ChapterType,
    value: number | string,
    isPrevStep = false,
  ) => {
    //check if sweep set by point or smart link and return it
    const destinationSweepData = parsePathDestinationSweepData(currentPathStep?.current);
    const pathSweep = sweeps.find((sweep) => destinationSweepData?.sweepUuid === sweep.uuid);
    let obj: any;
    switch (type) {
      case ChapterType.Tag: {
        const allTagsArray = Array.from(allTags, ([, v]: any) => v);
        obj = allTagsArray?.find(
          (item) =>
            value?.toString() === item.id.toString() ||
            value === item?.id ||
            value === item.sid ||
            value === item.defaultSid,
        );
        break;
      }
      case ChapterType.Polygon: {
        obj = polygons.find((item) => value?.toString() === item?.id?.toString());
        break;
      }
      case ChapterType.VSImage: {
        obj = vsObjects.find(
          (item) => item instanceof TourImage && value?.toString() === item.id.toString(),
        );
        break;
      }
      case ChapterType.VSVideo: {
        obj = vsObjects.find(
          (item) => item instanceof TourVideo && value?.toString() === item.id.toString(),
        );
        break;
      }
      case ChapterType.VSItem: {
        obj = vsObjects.find(
          (item) => item instanceof TourObject && value?.toString() === item.id.toString(),
        );
        break;
      }
      default:
        break;
    }
    if (obj && pathSweep) {
      const THREE = await iTHREE();

      let transitionType =
        (isPrevStep
          ? currentPathStep.current?.next?.transitionType
          : currentPathStep.current?.transitionType) || GameLockPathTransitionType.INSTANT;
      if (transitionType?.toUpperCase() === GameLockPathTransitionType.MANUAL)
        transitionType = GameLockPathTransitionType.FLY;
      await showcase.Sweep.moveTo(pathSweep.uuid, {
        transition: showcase.Sweep.Transition[transitionType?.toUpperCase()],
      });

      if (asyncStore.vrIsOn && obj) rotateVRView(pathSweep, obj);
      if (!asyncStore?.vrIsOn) {
        if (destinationSweepData.isTourLink) {
          await setRotation({ x: destinationSweepData.x, y: destinationSweepData.y });
        } else {
          await rotateCameraTo(new THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ));
        }
      }
    }
    return obj;
  };

  const isHasItemInCondition = (step) => {
    const conditions = game.conditions.filter(
      (condition: GameCondition) =>
        !condition.lock_ids.length && condition.conditionType === ConditionType.HIDE,
    );
    const conditionByLocationType = conditions.find(
      (condition) =>
        condition.entity_type === step?.locationType &&
        condition.conditionType === ConditionType.HIDE,
    );
    return Boolean(
      conditionByLocationType &&
        conditionByLocationType?.entity_ids?.includes(step?.next?.locationItem?.toString()),
    );
  };

  const goToNextStep = async (forceCloseLockPathInLastStep = false, forcedLockPath?: GameLock) => {
    const _lockPath = forcedLockPath || lockPath || tagRefForData.current?.lockPath;
    const nextStepId: any = currentPathStep?.current?.next?.id;
    // ---- hide path after last item clicked
    if (!currentPathStep?.current?.next) {
      // setShowPathLock(false);
      previousPathStep.current = currentPathStep.current;
      currentPathStep.current = null;
    }
    if (nextStepId && paths.current.has(nextStepId)) {
      setPassedPath(nextStepId);
      console.debug('aaa goToNextStep 0 next step applying');
      const step = paths.current.get(nextStepId);
      const delay = parseInt(step?.appearanceDelay);
      if (_lockPath?.hideItems && !isHasItemInCondition(currentPathStep?.current)) {
        const allTagsArray = Array.from(allTags, ([, value]: any) => value);
        const tagsToReveal =
          step.locationType === EntityType.Tag
            ? allTagsArray.filter(
                (tag) =>
                  tag?.id === step.locationItem ||
                  tag.sid === step.locationItem ||
                  tag.defaultSid === step.locationItem,
              )
            : [];
        const polygonsToReveal =
          step.locationType === EntityType.Polygon
            ? polygons.filter(
                (polygon) =>
                  polygon.id === step.locationItem || polygon.id?.toString() === step.locationItem,
              )
            : [];
        const vsImagesToReveal =
          step.locationType === EntityType.VSImage
            ? vsObjects.filter(
                (object) =>
                  object instanceof TourImage &&
                  (object.id === step.locationItem || object.id?.toString() === step.locationItem),
              )
            : [];
        const vsVideosToReveal =
          step.locationType === EntityType.VSVideo
            ? vsObjects.filter(
                (object) =>
                  object instanceof TourVideo &&
                  (object.id === step.locationItem || object.id?.toString() === step.locationItem),
              )
            : [];
        const vsItemsToReveal =
          step.locationType === EntityType.VSItem
            ? vsObjects.filter(
                (object) =>
                  object instanceof TourObject &&
                  (object.id === step.locationItem || object.id?.toString() === step.locationItem),
              )
            : [];

        const objUuid = await showElements({
          tagsToReveal: tagsToReveal.map((e) => e.element?.sid || e?.sid),
          polygonsToReveal: polygonsToReveal.map((e) => e?.id?.toString()),
          vsImagesToReveal: vsImagesToReveal.map((e) => e?.id?.toString()),
          vsVideosToReveal: vsVideosToReveal.map((e) => e?.id?.toString()),
          vsItemsToReveal: vsItemsToReveal.map((e) => e?.id?.toString()),
        });

        if (objUuid) {
          step.element.uuid = objUuid;
        }
      }
      //if delay then path will appear with timeout / reset previous timeout
      handlePathDelay(delay, setDelayedDisable);
      if (currentPathStep.current?.hideStep) {
        //hide clicked element
        __hideConditions(
          [
            {
              conditionType: 'hide',
              entity_type: currentPathStep?.current?.locationType,
              entity_ids: [currentPathStep?.current?.locationItem],
            },
          ],
          { skipAddToRevealed: true },
        );
      }
      pathGameLockDataSnapshots[step?.id] = gameLockData;
      const prevStep = currentPathStep?.current;
      previousPathStep.current = currentPathStep.current;
      currentPathStep.current = step;

      togglePreviosPathLock(!!currentPathStep?.current?.prev);
      toggleNextPathLock(true);

      if (skipPathTo && skipPathTo !== prevStep.id) {
        goToNextStep(undefined, _lockPath);
      } else {
        skipPathTo = null;
      }
    } else {
      console.debug(
        'aaa goToNextStep 1 finishing path',
        forcedLockPath,
        lockPath,
        currentPathStep.current,
        tagRefForData.current?.lockPath,
      );
      skipPathTo = null;
      const { multiPaths } = window as any;
      const updatedPaths = multiPaths.map((path) => {
        if (path.id === _lockPath?.id) {
          return { ...path, endTime: Date.now() };
        }
        return path;
      });
      // @ts-ignore
      window.multiPaths = updatedPaths;
      const newFinishedPaths = [...finishedPaths, _lockPath?.id];
      //check if there is another uncomoleted paths?
      //switching to available path
      // const unfinishedPaths = game?.paths.filter((path) => !newFinishedPaths.includes(path.id));
      // if (unfinishedPaths.length > 0) {
      //   _changePath(unfinishedPaths[0].id);
      // }
      ///TODO set no active path
      previousPathStep.current = currentPathStep.current;
      currentPathStep.current = null;
      paths.current = null;
      asyncStore.pathIds = [];
      console.debug('aaa setLockPath null 3');
      setLockPath(null);

      // else if (forceCloseLockPathInLastStep) {
      //   setShowPathLock(false);
      //   currentPathStep.current = null;
      // }
      if (pathEndMark.current) {
        removePathEndMark();
      }

      setFinishedPaths(newFinishedPaths);
    }
    //force update of path, because it's using data from reference which is not updating it's Reference
    setUpdateState((updateState) => !updateState);
  };

  const goToCurrentStep = async () => {
    const currentStepId: any = currentPathStep?.current?.id;
    if (currentStepId) {
      const step = paths.current.get(currentStepId);
      previousPathStep.current = currentPathStep.current;
      currentPathStep.current = step;
      toggleNextPathLock(true);
    }
  };

  const resetStepsToDefault = async (pathLockId) => {
    const pathToResetSteps = pathSnapshot[pathLockId];
    const path = game?.paths.find((p) => p.id === pathLockId || p.id?.toString() === pathLockId);

    if (pathToResetSteps) {
      const { currentPathStep, pathIds, paths } = pathToResetSteps;
      const lastStepIndex = pathIds.findIndex((pathId) => pathId === currentPathStep.id);
      const stepsIdToRevert = pathIds.slice(0, lastStepIndex).reverse();
      return Promise.all(stepsIdToRevert.map(async (stepId) => resetStep(path, paths.get(stepId))));
    }
  };

  const resetStep = async (path, step) => {
    // 1. restore tags
    asyncStore.restoreTagsTimeline[step?.id]?.forEach((sid) => {
      //@ts-ignore
      const tag = allTags?.get(sid);
      const iconId = getTagIconId(tag);
      // ToDo: duplicated with initTags (BaseTour.tsx)
      if (iconId) {
        let iconUrl;
        if (tag.iconFile) {
          if (tag.iconFile.startsWith('http')) {
            iconUrl = `${tag.iconFile}`;
          } else {
            iconUrl = `${process.env.NEXT_PUBLIC_CDN}/tours/${tag.tourId}/tags/icons/${tag.iconFile}`;
          }
        } else if (tag.customIcon) {
          iconUrl = tag.iconColor
            ? `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${tag.customIcon}?hex=${encodeURIComponent(tag.iconColor)}&circle=${tag.whiteCircle}`
            : `${process.env.NEXT_PUBLIC_API}/v1/public/icons/${tag.customIcon}`;
        }

        registerIcon({ iconId, url: iconUrl })
          .then(() => {
            console.log(tag);
            editIcon(sid, iconId).catch((e) => {
              console.error(e);
            });
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        resetIcon(sid).catch((e) => {
          console.error(e);
        });
      }
    });

    // 2. reveal previous hidden element
    if (step?.hideStep) {
      __revealConditions([
        {
          conditionType: 'reveal',
          entity_type: step?.locationType,
          entity_ids: [step?.locationItem],
        },
      ]);
    }
    // 3.
    if (path?.hideItems && !isHasItemInCondition(step)) {
      const allTagsArray = Array.from(allTags, ([, value]: any) => value);
      const tagsToReveal =
        step.locationType === EntityType.Tag
          ? allTagsArray.filter(
              (tag) =>
                tag?.id === step.locationItem ||
                tag.sid === step.locationItem ||
                tag.defaultSid === step.locationItem,
            )
          : [];
      const polygonsToReveal =
        step.locationType === EntityType.Polygon
          ? polygons.filter(
              (polygon) =>
                polygon.id === step.locationItem || polygon.id?.toString() === step.locationItem,
            )
          : [];
      const vsImagesToReveal =
        step.locationType === EntityType.VSImage
          ? vsObjects.filter(
              (object) =>
                object instanceof TourImage &&
                (object.id === step.locationItem || object.id?.toString() === step.locationItem),
            )
          : [];
      const vsVideosToReveal =
        step.locationType === EntityType.VSVideo
          ? vsObjects.filter(
              (object) =>
                object instanceof TourVideo &&
                (object.id === step.locationItem || object.id?.toString() === step.locationItem),
            )
          : [];
      const vsItemsToReveal =
        step.locationType === EntityType.VSItem
          ? vsObjects.filter(
              (object) =>
                object instanceof TourObject &&
                (object.id === step.locationItem || object.id?.toString() === step.locationItem),
            )
          : [];

      const objUuid = await showElements({
        tagsToReveal: tagsToReveal.map((e) => e.element?.sid),
        polygonsToReveal: polygonsToReveal.map((e) => e?.id?.toString()),
        vsImagesToReveal: vsImagesToReveal.map((e) => e?.details?.id?.toString()),
        vsVideosToReveal: vsVideosToReveal.map((e) => e?.details?.id?.toString()),
        vsItemsToReveal: vsItemsToReveal.map((e) => e?.details?.id?.toString()),
      });

      if (objUuid) {
        step.element.uuid = objUuid;
      }
    }

    // 4. revert locks/conditions for this step
    const locksToRevert = asyncStore.locksPathTimeline[step?.id] || [];

    const previousLocksToRevert = [];

    const hideConditionsToRevert = asyncStore.hidePathTimeline[step?.id] || [];
    const previousHideConditionsToRevert = [];

    const revealConditionsToRevert = asyncStore.revealPathTimeline[step?.id] || [];
    const previousRevealConditionsToRevert = [];

    const fullListOfLocksToRevert = [...locksToRevert, ...previousLocksToRevert];
    const fullListOfHideConditionsToRevert = [
      ...hideConditionsToRevert,
      ...previousHideConditionsToRevert,
    ];
    const fullListOfRevealConditionsToRevert = [
      ...revealConditionsToRevert,
      ...previousRevealConditionsToRevert,
    ];
    const revertRevealConditionsIds = fullListOfRevealConditionsToRevert?.map(
      (condition) => condition.id,
    );

    //remove items from inventory for collect locks
    removeFromCollectItemsBackpack(fullListOfLocksToRevert.map((lock) => lock.lockId));
    //remove from clicked elements itemsToRemove: {id: number|string, type: string}[]
    removeFromClickedElements(
      fullListOfLocksToRevert.map((lock) => ({
        id: lock.locationItem,
        type: lock.locationType,
      })),
    );

    const newLocks = solvedLocks.filter(
      (lockId) => !fullListOfLocksToRevert?.map((lock) => lock.lockId)?.includes(lockId),
    );
    const newConditions = revealedConditions.filter(
      (conditionId) =>
        !(
          hideConditionsToRevert?.map((e) => e.id)?.includes(conditionId) ||
          revealConditionsToRevert?.map((e) => e.id)?.includes(conditionId)
        ),
    );

    await __revealConditions(fullListOfHideConditionsToRevert, { skipAddToRevealed: true });
    await __hideConditions(fullListOfRevealConditionsToRevert, { skipAddToRevealed: true });
    // Updating state.game.conditions with the correct isRevealed property for renderVs() -> filterVsElementsByGameCondition() to use when rendering vsItems
    await setGameState({
      ...game,
      conditions: game?.conditions?.map((c) => {
        if (revertRevealConditionsIds.includes(c.id)) {
          return { ...c, isRevealed: false };
        }
        return c;
      }),
    });

    //remove reverted locks
    asyncStore.locksPathTimeline[currentPathStep?.current?.id] = [];
    //remove hiddenConditions that was revealed
    asyncStore.hidePathTimeline[currentPathStep?.current?.id] = [];
    //remove revealedConditions that was hidden
    asyncStore.revealPathTimeline[currentPathStep?.current?.id] = [];

    fullListOfLocksToRevert
      .map((l) => l.lockId)
      .forEach((lId) => {
        delete gameLockData[lId];
      });
    setGamePoints(
      gamePoints - fullListOfLocksToRevert?.reduce((acc, lock) => acc + lock.lockPoint, 0),
    );
    setSolvedLocks(newLocks);

    setRevealedConditions(newConditions);
  };

  const goToPreviousStep = async (forcedLockPath = undefined, restart = false) => {
    const _lockPath = forcedLockPath || lockPath;
    setIsClickPrev(true);
    const prevStep = currentPathStep?.current?.prev?.id;
    if (prevStep && paths.current.has(prevStep)) {
      const step = paths.current.get(prevStep);
      await resetStep(_lockPath, step);
      previousPathStep.current = currentPathStep.current;
      currentPathStep.current = step;
      if (step?.hideStep) {
        //hide clicked element
        __revealConditions(
          [
            {
              conditionType: 'reveal',
              entity_type: step?.locationType,
              entity_ids: [step?.locationItem],
            },
          ],
          { skipAddToRevealed: true },
        );
      }
      togglePreviosPathLock(!!currentPathStep?.current?.prev);
      if (restart && step.prev) {
        goToPreviousStep(_lockPath, true);
      }
    }

    analytic.update({ point: gamePoints });
  };

  const showExperiencePopupByConditionPathLock = (currentPathId: number) => {
    const { conditions } = game;
    const currentCondition = conditions.find((condition: GameCondition) => {
      const isExperiencePopupContentType =
        condition.content_type === ContentType.ExperiencePopupVideo ||
        condition.content_type === ContentType.ExperiencePopupImage;
      return isExperiencePopupContentType && currentPathId === condition.lockPathId;
    });
    if (currentCondition) {
      callExperiencePopup({
        experiencePopUpData: {
          title: currentCondition.experienceTitle,
          description: currentCondition.experienceDescription,
          url: currentCondition.content_value,
          prefixImageUrl: `/games/${game.id}/conditions/${currentCondition.id}/`,
          autoClose: currentCondition.autoClose,
        },
        experiencePopUpIsOpen: true,
        onExperienceCloseCallback: async () => {
          console.log('aaa goToNextStep 4');
          //  await goToNextStep();
        },
      });
    }
  };

  const handleNextStep = useCallback(async () => {
    const { multiPaths } = window as any;
    const _lockPath = tagRefForData.current?.lockPath;
    let updatedPaths;
    if (!multiPaths) {
      updatedPaths = [
        {
          id: _lockPath.id,
          name: _lockPath.name,
          startTime: Date.now(),
          currentStep: (asyncStore?.pathIds || [])?.indexOf(currentPathStep?.current.id) + 1,
          stepsLength: asyncStore?.pathIds?.length,
        },
      ];
    } else {
      updatedPaths = multiPaths.map((path) => {
        if (path.id === _lockPath?.id) {
          return {
            ...path,
            currentStep: (asyncStore?.pathIds || [])?.indexOf(currentPathStep?.current?.id) + 1,
          };
        }
        return path;
      });
      const existingPath = multiPaths.find((path) => path.id === _lockPath.id);
      if (!existingPath) {
        updatedPaths.push({
          id: _lockPath.id,
          name: _lockPath.name,
          startTime: Date.now(),
          currentStep: (asyncStore?.pathIds || [])?.indexOf(currentPathStep?.current.id) + 1,
          stepsLength: asyncStore?.pathIds?.length,
        });
      }
    }

    // @ts-ignore
    window.multiPaths = updatedPaths;

    if (!currentPathStep?.current) return;
    setIsClickPrev(false);
    setPassedPath(currentPathStep.current.id);
    if (!isMovingToPath && gameStatus === GameStatus.Started) {
      setIsMovingToPath(true);
      const _lockPath = lockPath || tagRefForData.current?.lockPath;
      if (currentPathStep?.current.sweepUuid != currentSweep.uuid) {
        const vsElement = await moveToPathStepElement(
          currentPathStep.current.locationType,
          currentPathStep.current.locationItem,
        );
        showExperiencePopupByConditionPathLock(currentPathStep.current.id);

        if (currentPathStep.current?.autoOpenDestination) {
          openVsIframe(vsElement, currentPathStep.current.locationType);
        }
        if (
          currentPathStep.current?.locationType === LockLocationType.vsItem ||
          _lockPath.allowSkipping
        ) {
          await goToCurrentStep();
        } else {
          toggleNextPathLock(false || _lockPath.allowSkipping);
        }
      } else if (isEnableNextPathLock) {
        const vsElement = await moveToPathStepElement(
          currentPathStep.current.locationType,
          currentPathStep.current.locationItem,
        );
        showExperiencePopupByConditionPathLock(currentPathStep.current.id);
        if (currentPathStep.current?.autoOpenDestination) {
          openVsIframe(vsElement, currentPathStep.current.locationType);
        }

        if (
          currentPathStep.current?.locationType === LockLocationType.vsItem ||
          _lockPath.allowSkipping
        ) {
          await goToNextStep();
          if (_lockPath.allowSkipping && currentPathStep.current) {
            await moveToPathStepElement(
              currentPathStep.current.locationType,
              currentPathStep.current.locationItem,
            );
          } else if (_lockPath.allowSkipping && !currentPathStep.current) {
            const nextGameStatus: any = game.outroClip
              ? GameStatus.OutroClip
              : game.finishScreenOn
              ? GameStatus.SuccessfullyEnded
              : GameStatus.SuccessfullyEndedWithoutFinalScreen;
            setGameStatus(nextGameStatus);
            await analytic.update({ point: gamePoints, completed: true });
            onGameEnd();
          }
        } else {
          toggleNextPathLock(false);
        }
      }
      setIsMovingToPath(false);
    }
    if (soundOn) await lockPathAudioClick.current.play();
  }, [
    goToCurrentStep,
    goToNextStep,
    isEnableNextPathLock,
    moveToPathStepElement,
    showExperiencePopupByConditionPathLock,
    soundOn,
  ]);

  const handlePreviousStep = async () => {
    setPassedPath(currentPathStep.current.id, true);

    await goToPreviousStep();
    const vsElement = await moveToPathStepElement(
      currentPathStep.current.locationType,
      currentPathStep.current.locationItem,
      true,
    );
    showExperiencePopupByConditionPathLock(currentPathStep.current.id);
    if (currentPathStep.current?.autoOpenDestination) {
      openVsIframe(vsElement, currentPathStep.current.locationType);
    }
    if (soundOn) await lockPathAudioClick.current.play();
  };

  const handleExpPopClose = () => {
    if (popupsToFulfill.current && popupsToFulfill.current?.length) {
      if (popupsToFulfill.current?.length === 1 && popupsToFulfill.current?.cb) {
        popupsToFulfill.current?.cb();
        popupsToFulfill.current = null;
      } else {
        popupsToFulfill.current.length--;
      }
    }
  };

  const onEndExperience = game.timerOn
    ? () => {
        setShowTimeIsUpModal(true);
        onGameEnd();
        setGameStatus(GameStatus.TimeIsUpEnded);
        analytic.update({ completed: false });
      }
    : () => undefined;

  const _changePath = async (pathId: any, restart?: boolean) => {
    // lockPath?.id - the path from which we will switch
    // pathId - new active path
    if (lockPath?.id === pathId) return;
    /// TODO test this
    let skipChangePath = false;
    const path = game?.paths.find((p) => p.id === pathId || p.id?.toString() === pathId);
    const { multiPaths } = window as any;

    // When 'restart' need to start from the beginning.
    // Need to reset all complited steps and remove a snaphot from state.
    if (restart) {
      await resetStepsToDefault(pathId);
      delete pathSnapshot[pathId];
      const updatedPaths = multiPaths.filter((path) => path.id !== pathId);
      // @ts-ignore
      window.multiPath = updatedPaths;
    }

    // Take snapshot of the path we are coming from before switching to new path
    pathSnapshot[lockPath?.id] = {
      currentPathStep: currentPathStep.current,
      paths: paths.current,
      pathIds: asyncStore.pathIds,
    };
    previousPathStep.current = currentPathStep.current;

    // Does user work with new path?
    // If YES restore prev state
    if (pathSnapshot[pathId]) {
      currentPathStep.current = pathSnapshot[pathId]?.currentPathStep;
      paths.current = pathSnapshot[pathId]?.paths;
      asyncStore.pathIds = pathSnapshot[pathId]?.pathIds;

      if (skipPathTo) {
        skipChangePath = true;
        goToNextStep(undefined, path);
      }
    } else {
      currentPathStep.current = null;
      paths.current = null;
      asyncStore.pathIds = [];
    }

    if (!skipChangePath) {
      console.debug('aaa setLockPath _changePath 2', path);
      setLockPath(path);
    }

    // If path doesn't exist yet, createPathEndMark is called during initLockPath()
    if (paths.current) {
      let pathArray = Array.from(paths.current, ([, value]: any) => value);
      if (pathArray.length) createPathEndMark(pathArray);
    }
    asyncStore.regularActivePath = game?.paths.map((p) => p.id).indexOf(path.id);
  };
  // console.debug('aaa -----------------------------------------------------------------------');
  // console.debug('aaa game', game);
  // console.debug('aaa lockPath', lockPath);
  // console.debug('aaa finishedPaths', finishedPaths);
  // console.debug('aaa currentPathStep.current', currentPathStep.current);
  // console.debug('aaa paths.current', paths.current);
  // console.debug('aaa asyncStore.pathIds', asyncStore.pathIds);
  // console.debug('aaa isShowPathLockByExperience', isShowPathLockByExperience);

  useEffect(() => {
    if (vrEventManager)
      vrEventManager.addEventListener(
        { type: 'pointerdown', button: 5, controller: ControllerType.GamepadL },
        () => {
          moveToPathStepElement(
            currentPathStep.current.locationType,
            currentPathStep.current.locationItem,
            true,
          );
        },
      );
  }, []);

  return host && !participantId ? null : (
    <>
      <TimerWrap
        timerCondition={timerCondition}
        isRtl={isRtl}
        username={username}
        gamePoints={gamePoints}
        gameStatus={gameStatus}
        game={game}
        analytic={analytic}
        onEndExperience={onEndExperience}
        gameTimeRef={gameTimeRef}
        gameTimerTranslations={{
          points: translation.points,
          experienceTime: translation.experienceTime,
          progressTrnslt: translation.progress,
        }}
        hasClientLogo={!!hasClientLogo}
      />

      {baseCondition && (
        <Sidebar
          showPathSwitch={game?.paths?.length > 1}
          translation={translation}
          // Settings
          whiteLabel={whiteLabel}
          tour={tour}
          mainPlaying={mainPlaying}
          initialDuplicates={initialDuplicates}
          game={game}
          username={username}
          analytic={analytic}
          gameStatus={gameStatus}
          gamePoints={gamePoints}
          showBackpack={showBackpack}
          backpackNewItems={backpackNewItems}
          showBook={showBook}
          setBaseState={setBaseState}
          onEndExperience={onEndExperience}
          // Hub
          showParticipantsIcon={showParticipantsIcon}
          showParticipantsReel={showParticipantsReel}
        />
      )}
      {baseCondition && game?.book && (
        <GameBookHandle
          gameBook={game.book}
          showBook={showBook}
          showBookBtn={showBookBtn}
          closeGameBook={closeGameBook}
          unlockedChapterIds={unlockedChapterIds}
          tryButtonPlaySound={tryButtonPlaySound}
          moveToSweep={moveToSweep}
          onToggleGameBookModal={onToggleGameBookModal}
          tourType={tourType}
        />
      )}
      {isShowPathLockByExperience && (
        <DesktopSwitchPath
          finishedPaths={finishedPaths}
          gameId={game.id}
          pathLocks={game?.paths}
          pathLockId={lockPath?.id}
          currentPathStepId={currentPathStep?.current?.id}
          handleChangePath={(ev: any) => {
            console.log('aaa handleChangePath 11');
            handleChangePath(ev);
          }}
        />
      )}
      {isShowPathLockByExperience && !hidePath && !panoIsOpen && lockPath?.paths?.length && (
        <GamePathLockStyleFix>
          <GameLockPathModal
            pathSnapshot={pathSnapshot}
            forceShowPathSwitchMobileModal={forceShowPathSwitchMobileModal}
            setForceShowPathSwitchMobileModal={setForceShowPathSwitchMobileModal}
            theme={theme}
            APP_AWS={process.env.NEXT_PUBLIC_CDN}
            useRecoilValue={useRecoilValue}
            recoilStateObj={{ bottomBarOpenState, tourConfigsState }}
            asyncStore={asyncStore}
            color={color}
            currentPathStepId={currentPathStep?.current?.id}
            pathfinderDataState={pathfinderDataState}
            setPathfinderDataState={setPathfinderDataState}
            delayedDisable={delayedDisable}
            isRtl={isRtl}
            pathLockId={lockPath?.id}
            gameId={game.id}
            pathSettings={lockPath?.pathSetting || {}}
            handleNextStep={handleNextStep}
            translation={translation}
            title={currentPathStep?.current?.title}
            description={currentPathStep?.current?.description}
            distance={
              currentPathStep?.current?.transitionType === GameLockPathTransitionType.MANUAL
                ? distanceToNextPathStep
                : undefined
            }
            isEnablePreviousStep={lockPath?.previousStep && isEnablePrevPathLock}
            handlePreviousStep={handlePreviousStep}
            // @ts-ignore
            buttonOnlyMode={lockPath?.buttonOnlyMode}
            nextButtonVisibility={lockPath?.nextButtonVisibility}
            // @ts-ignore property added to types
            isEnableNextStep={isEnableNextStep}
            // @ts-ignore property added to types
            icon={currentPathStep?.current?.icon}
          />
        </GamePathLockStyleFix>
      )}
      {showTimeIsUpModal && (
        <TimeIsUpModal
          showTimeIsUpModal={showTimeIsUpModal}
          getCurrentLanguage={getCurrentLanguage}
          timeUpImg={game.timeUpImg}
          timeUpImgMob={game.timeUpImgMob}
          timeUpVideo={game.timeUpVideo}
          timeUpImgMobH={game.timeUpImgMobH}
          timeUpImgH={game.timeUpImgH}
          timeUpImgW={game.timeUpImgW}
          timeUpImgMobW={game.timeUpImgMobW}
          timeUpRes={game.timeUpRes}
          timeUpMobVideo={game.timeUpMobVideo}
          tourId={tour.id}
          gameId={game.id}
          isWhiteLabel={!!whiteLabel?.active}
        />
      )}
      <ConditionModal
        show={baseCondition && showConditionModal}
        gameId={tour.gameId}
        condition={currentCondition}
        onClose={closeConditionPopup}
        initialDuplicates={initialDuplicates}
      />
      <GuideModal
        show={showGuide}
        onContinue={toggleGuide}
        translation={translation}
        logo={whiteLabel?.logo}
      />
    </>
  );
};

export default memo(GameplayScreen);
